import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import useGroupes from "./hooks/useGroupes";

import GroupesHeader from "./components/GroupesHeader";
import GroupesStats from "./components/GroupesStats";
import GroupesTable from "./components/GroupesTable";
import GroupFormDrawer from "./components/GroupFormDrawer";

const Groupes = ({ sectionId }) => {
  const {
    finalSectionId,
    rows,
    stats,
    loading,
    saving,
    demoMode,

    searchTerm,
    setSearchTerm,
    statusFilter,
    setStatusFilter,

    drawer,
    openCreateDrawer,
    openEditDrawer,
    closeDrawer,

    fetchGroupes,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useGroupes(sectionId);

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1400px] space-y-5">
        <GroupesHeader
          loading={loading}
          demoMode={demoMode}
          sectionId={finalSectionId}
          onRefresh={fetchGroupes}
          onCreate={openCreateDrawer}
        />

        <GroupesStats stats={stats} />

        <GroupesTable
          rows={rows}
          loading={loading}
          searchTerm={searchTerm}
          statusFilter={statusFilter}
          onSearchChange={setSearchTerm}
          onStatusFilterChange={setStatusFilter}
          onEdit={openEditDrawer}
          onDelete={handleDelete}
        />
      </div>

      <GroupFormDrawer
        isOpen={drawer.type === "create"}
        mode="create"
        saving={saving}
        onClose={closeDrawer}
        onCreate={handleCreate}
      />

      <GroupFormDrawer
        isOpen={drawer.type === "edit"}
        mode="edit"
        group={drawer.group}
        saving={saving}
        onClose={closeDrawer}
        onUpdate={handleUpdate}
      />

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
};

export default Groupes;